import * as R from 'ramda';
import memoize from 'memoize-one';

const getApp = R.prop('app');

// --- Static Selectors ---
export const getAppBarsOffset = memoize((state) =>
  R.prop('appBarsOffset', getApp(state)),
);

export const getVisPageWidth = memoize((state) =>
  R.prop('visPageWidth', getApp(state)),
);

export const getPending = memoize((state) => R.prop('pending', getApp(state)));

const getLogs = memoize((state) => R.prop('logs', getApp(state)));

// --- Selector Factories (Dynamic Selectors) ---
export const getQueryKey = (key = '') =>
  memoize((state) => R.pathOr([], ['queryKeys', key], getApp(state)));

export const getExtAuthOptions = (spaceId) =>
  memoize((state) => R.pathOr({}, ['extAuthOptions', spaceId], getApp(state)));

export const getIsPending = (id) =>
  memoize((state) => R.propEq(true, id, getPending(state)));

export const getLog = (name, prop = 'type') =>
  memoize((state) => R.find(R.propEq(name, prop), getLogs(state)));
